import produce from 'immer';
import {
  NFT_TRANSACTIONLOG_LIST_REQUEST, NFT_TRANSACTIONLOG_LIST,
  SET_TOTAL_COUNT, SET_NFT_TRANSACTIONLOG_PAGINATION, NFT_TRANSACTIONLOG_PAGE_RESET,
} from '../../constants/log/nftTransactionLogConstants';
import moment from 'moment';

const initialState = {
  page: 1,
  pageLength: 10,
  beginDate: moment().utc().subtract(3, 'days').format('YYYY-MM-DDT00:00:00'),
  endDate: moment().utc().format('YYYY-MM-DDT23:59:59'),
  searchCode: '',
  searchString: '',
  totalCount: 0,
};

const nftTransactionLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case NFT_TRANSACTIONLOG_LIST_REQUEST:
      break;
    case NFT_TRANSACTIONLOG_LIST:
      draft.list = action.list;
      break;
    case SET_TOTAL_COUNT:
      draft.totalCount = action.totalCount;
      break;
    case SET_NFT_TRANSACTIONLOG_PAGINATION:
      draft.page = action.page;
      draft.totalCount = action.totalCount;
      draft.beginDate = action.beginDate;
      draft.endDate = action.endDate;
      draft.searchCode = action.searchCode;
      draft.searchString = action.searchString;
      break;
    case NFT_TRANSACTIONLOG_PAGE_RESET:
      draft.page = 1;
      break;
    default:
      break;
  }
});

export default nftTransactionLogReducer;
